module.exports = __webpack_public_path__ + "static/media/i41.563235d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i41.svg
// module id = 107
// module chunks = 8